import * as React from 'react';
import { CustomTooltip } from '@cian/ui-kit';

import { useChatOnboarding } from './hooks/useChatOnboarding';

export const ConsultantCianChatOnboarding = ({ anchorRef }: { anchorRef: React.RefObject<HTMLButtonElement> }) => {
  const { open, closeHandler } = useChatOnboarding();

  return (
    <CustomTooltip
      anchorRef={anchorRef}
      content={<div onClick={closeHandler}>Задайте вопрос консультанту по&nbsp;новостройкам</div>}
      theme="blue"
      maxWidth={140}
      placement="top-end"
      open={open}
      onClose={closeHandler}
      flip={false}
      portal={false}
      arrow={true}
      outside={true}
    />
  );
};
